import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { reloadForStaleChunk } from 'utils/stale-chunk';

// A lazy chunk of a build that is no longer on the server (G2-2): reload once.
// The event is left un-cancelled so the same rejection reaches the ErrorBoundary,
// which holds the error screen back while the reload is in flight.
window.addEventListener('vite:preloadError', (event) => {
  reloadForStaleChunk(event.payload);
});

// No <React.StrictMode>: MUI 4 relies on findDOMNode, which React 18 warns
// about on every render in strict mode (D-24).
createRoot(document.getElementById('root') as HTMLElement).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
